export default __webpack_public_path__ + "static/media/addCart.cea78a9c.svg";